/* eslint-disable no-unused-vars */
/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  async getList({ commit }, { id, query }) {
    try {
      const response = await axios.get(
        `students/${id}/plans?${new URLSearchParams(query)}`,
      );
      if (response.status === 200) {
        commit("SET_LIST", response.data.data);
      }
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  create({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`students/${id}/plans`, payload)
        .then((response) => {
          // commit('CREATE_SUCCESS', response.data.data)
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, { id, planId, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`students/${id}/plans/${planId}`, payload)
        .then((response) => {
          // commit('UPDATE_SUCCESS', response.data.data)
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  async deleteMultiple({ commit }, payload) {
    return await axios.post("students/plans/delete-multiple", payload);
  },
  setPagination({ commit }, page) {
    commit("SET_PAGINATION", page);
  },
};
